import {useMemo} from 'react';
import {useKeycloak} from '@react-keycloak/web';
import {getFactsheetId} from '../helpers/helper';
import {EFactsheetClasses} from '../enums/EFactsheetClasses';
import {type IUsageTrackingInfo} from '../models/usage-tracking/IUsageTracking';
import { type EAppTypeValue } from '../enums/AppType';
import {SourceType} from '../enums/SourceType';
import {type ISourceTuple} from '../models/usage-tracking/ISourceTuple';


export function useUsageTrackingInfo(app: EAppTypeValue, sourceTuple?: ISourceTuple): IUsageTrackingInfo {
  const {keycloak} = useKeycloak();
  const factsheetId = getFactsheetId(EFactsheetClasses.US_AMERICAN_STOCKS);

  return useMemo(() => {

    // If custom sourceTuple is provided, use it directly
    if (sourceTuple) {
      return {
        app,
        sourceType: sourceTuple.sourceType,
        sourceIdentifier: sourceTuple.sourceIdentifier,
      };
    }

    switch (true) {
      case keycloak.authenticated && Boolean(keycloak.subject):
        return {
          app,
          sourceType: SourceType.Keycloak,
          sourceIdentifier: keycloak.subject as string,
        };

      case Boolean(factsheetId):
        return {
          app,
          sourceType: SourceType.Factsheet,
          sourceIdentifier: factsheetId as string,
        };

      default:
        return {
          app,
          sourceType: SourceType.Visitor,
          sourceIdentifier: null,
        };
    }
  }, [app, keycloak.authenticated, keycloak.subject, factsheetId]);
}
